export const VEHICLE_CLASSES = [
    { value: 'Tractor Trailer', label: 'Van' },
    { value: 'Refrigerated', label: 'Refrigerated' },
    { value: '53 Flatbed', label: "53' Flatbed" },
    { value: '48 Flatbed', label: "48' Flatbed" },
    { value: 'Straight', label: 'Straight' },
];

export const MOVE_MODES = [
    { value: 'intermodal', label: 'Intermodal' },
    { value: 'over-the-road', label: 'Over-the-road' },
    { value: 'partial', label: 'Partial' },
    { value: 'ltl', label: 'LTL' },
    { value: 'expedited', label: 'Expedited' },
];

export const PICKUP_DATES = [
    { value: 0, label: 'Today' },
    { value: 1, label: 'Tomorrow' },
];

export const CURRENCIES = [
    { value: 'CAD', label: 'CAD' },
    { value: 'EUR', label: 'EUR' },
    { value: 'MXN', label: 'MXN' },
    { value: 'USD', label: 'USD' },
];
